<div>
    <h2 class="m-b-5" mat-dialog-title>Descargar calendario anterior</h2>
    <div mat-dialog-content [formGroup]="form">
        <div class="d-flex">
            <!-- Date - Fecha -->
            <div>
                    <mat-form-field class=" date required-date-field" floatLabel="always">
                        <mat-label>Desde</mat-label>
                        <input matInput formControlName="fecha" [matDatepicker]="fecha" (click)="fecha.open()">
                        <mat-datepicker-toggle matSuffix [for]="fecha"></mat-datepicker-toggle>
                        <mat-datepicker #fecha></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="form.get('fecha').invalid && form.get('fecha').touched">
                        <span *ngIf="form.get('fecha').errors.required" class="validation-span">
                            Obligatorio
                        </span>
                    </mat-error>

                    <mat-form-field class=" date required-date-field" floatLabel="always">
                        <mat-label>Hasta</mat-label>
                        <input matInput formControlName="hasta" [matDatepicker]="hasta" (click)="hasta.open()">
                        <mat-datepicker-toggle matSuffix [for]="hasta"></mat-datepicker-toggle>
                        <mat-datepicker #hasta></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="form.get('hasta').invalid && form.get('hasta').touched">
                        <span *ngIf="form.get('hasta').errors.required" class="validation-span">
                            Obligatorio
                        </span>
                    </mat-error>

                    <div class="date required-date-field" >
                        <mat-checkbox formControlName="CalSelect" [disabled]="!form.get('SoloPerfilSelect')?.value">
                            Solo calendario seleccionado
                        </mat-checkbox>
                    </div>
                    <div class="date required-date-field">
                        <mat-checkbox formControlName="SoloPerfilSelect">
                            Solo perfil seleccionado
                        </mat-checkbox>
                    </div>
            </div>
        </div>

        <!-- Date - Hasta -->
        

        <!-- Buttons -->
        <div class="text-a-r  m-t-10 m-b-10">
            <button (click)="onSave()" mat-raised-button color="accent" class="m-r-15">Aceptar</button>
            <button (click)="onCancel()" mat-raised-button color="warn">Cancelar</button>
        </div>
    </div>